const IMPORT = 1;
const EXPORT = 2;

export default {
	IMPORT,
	EXPORT,
};
